<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path
            class="shlcl1"
            d="m269.37,490.34c-11.55,2.03-23.13,1.01-34.65-.02-25.01-2.25-49.17-8.18-72.08-18.52-35.57-16.07-65.95-39.06-90.12-69.88-24.64-31.42-40.59-66.86-46.99-106.32-10.51-64.71,3.14-124.02,41.04-177.48,23.51-33.17,54.16-57.92,90.77-75.51,20.77-9.98,42.57-16.53,65.3-19.51,10.16-1.33,20.51-2.54,30.87-1.85,3.83,1.53,7.14,3.58,8.38,7.91,2.1,7.2-1.19,12.95-9.25,15.99-.69.07-1.39.18-2.08.2-33.91.91-65.83,9.15-95.34,26.03-39.31,22.5-69.88,53.24-88.86,94.97-15.52,34.13-22.17,69.68-19.18,107.13,2.3,28.67,10.55,55.59,23.38,81.07,15.15,30.06,37.59,53.98,64.81,73.46,37.57,26.89,79.64,39.35,125.69,38.79,4.27.3,8.56,0,11.89,3.83,5.29,6.08,4.1,13.4-3.61,19.75l.03-.03Z"
        />
        <path
            class="shlcl3"
            d="m269.37,490.34c7.71-6.35,8.92-13.67,3.61-19.75-3.33-3.81-7.62-3.53-11.89-3.83,4.5-1.24,9.14-.25,13.69-.76,26.52-2.92,52.03-9.34,75.83-21.87,38.51-20.29,69.38-48.38,90.02-87.21,21.08-39.6,29.51-81.52,24.35-126.21-3.46-30.03-13.49-57.79-28.31-83.87-11.32-19.88-26.5-36.64-43.88-51.36-28.25-23.9-60.39-39.77-96.83-46.81-14.33-2.77-28.75-3.46-43.26-3.56,8.04-3.06,11.34-8.78,9.25-15.99-1.26-4.32-4.55-6.38-8.38-7.91,33.05-.76,64.84,4.87,95.24,18.22,34.23,15.03,63.57,36.64,87.48,65.35,24.82,29.78,41.78,63.65,49.46,101.79,13.86,68.87.45,132.09-40.79,189-21.93,30.28-50.05,53.57-83.33,70.5-25.61,13.02-52.73,20.99-81.37,23.68-3.61.34-7.19,1.06-10.83.57h-.03Z"
        />
        <path
            class="shlcl1"
            d="m442.35,273.08c-3.26,48.64-22.27,90.22-57.52,123.57-40.49,38.32-89.08,56.08-144.92,52.46-26.65-1.71-52.03-8.87-75.37-21.9-49.83-27.83-82.34-69.38-95.86-125.08-3.17-13.1-4.28-26.72-4.55-40.31-.03-2.03.6-3.29,2.23-4.5,18.91-14.06,40.15-22.79,63.16-27.12,45.26-8.51,86.14,2.65,123.69,28.25.34.22.79.25,1.18.39,1.96,2.27,4.72,3.41,7.2,4.92,25.58,15.64,53.17,25.07,83.27,25.8,22.42.54,44.05-3.88,64.69-12.78,11.4-4.92,22.62-10.21,31.98-18.68.96,0,1.23.62,1.31,1.43-.77,4.5-.67,9.02-.47,13.55h-.02Z"
        />
        <path
            class="shlcl3"
            d="m441.51,258.1c-9.35,8.46-20.57,13.75-31.98,18.68-20.62,8.92-42.27,13.32-64.69,12.78-30.1-.72-57.69-10.16-83.27-25.8-2.47-1.51-5.22-2.65-7.2-4.92,22.74-15.28,47.34-25.88,74.67-29.51,38.46-5.11,73.74,3.91,106.42,24.28,2.12,1.33,4.03,2.99,6.03,4.48h.02Z"
        />
        <path
            class="shlcl3"
            d="m222.45,138.94c-.25-7.14,2.37-13.52,5.31-19.67,5.78-12.13,12.71-23.6,20.42-34.6,2.84-4.03,5.89-4.23,8.62-.24,8.92,13.03,17.23,26.42,23.26,41.11,7.15,17.43-.65,31.57-10.63,38.19-9.77,6.48-20.14,7.22-30.51,1.88-10.7-5.49-16.12-14.61-16.46-26.67v-.02Z"
        />
        <path
            class="shlcl2"
            d="m442.35,273.08c-.18-4.53-.29-9.05.47-13.55.45,4.53.64,9.07-.47,13.55h0Z"
        />
    </svg>
</template>
<style lang="scss">
.shlcl1,
.shlcl2,
.shlcl3 {
    fill: #000;
    stroke-width: 0px;
}

.shlcl1 {
    opacity: 0.75;
}
.shlcl3 {
    opacity: 0.45;
}
svg:hover {
    .shlcl1 {
        opacity: 0.95;
    }
    .shlcl3 {
        opacity: 0.65;
    }
}
html.dark {
    .shlcl1,
    .shlcl2,
    .shlcl3 {
        fill: #fff;
    }
    .shlcl1 {
        opacity: 0.45;
    }
    .shlcl3 {
        opacity: 0.75;
    }
    svg:hover {
        .shlcl1 {
            opacity: 0.65;
        }
        .shlcl3 {
            opacity: 0.95;
        }
    }
}
</style>
